<template>
  <div class="page-container">
    <hr class="divider" />
    <div class="iframe-wrapper">
      <div v-if="loading" class="loading-container">
        <b-spinner variant="primary" label="Carregando..."></b-spinner>
        <p>Carregando Compêndio...</p>
      </div>
      <div v-if="error" class="error-container">
        <b-alert variant="danger" show>
          <h4>Erro ao carregar o Compêndio</h4>
          <p>Não foi possível conectar com o serviço externo.</p>
          <b-button variant="outline-primary" @click="reloadIframe">
            <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
            Tentar novamente
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="openInNewTab"
            class="ml-2"
          >
            <b-icon-box-arrow-up-right></b-icon-box-arrow-up-right>
            Abrir em nova aba
          </b-button>
        </b-alert>
      </div>
      <iframe
        ref="compendioFrame"
        :src="iframeUrl"
        frameborder="0"
        allowfullscreen
        class="external-site-frame"
        :class="{ hidden: loading || error }"
        @load="onIframeLoad"
        @error="onIframeError"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageCompendio",
  data() {
    return {
      loading: true,
      error: false,
      iframeUrl: "https://front-compendio.vercel.app/consult/",
      loadTimeout: null,
    };
  },
  mounted() {
    this.loadTimeout = setTimeout(() => {
      if (this.loading) {
        this.error = true;
        this.loading = false;
      }
    }, 15000); // 15 segundos timeout
  },
  beforeDestroy() {
    if (this.loadTimeout) {
      clearTimeout(this.loadTimeout);
    }
  },
  methods: {
    onIframeLoad() {
      this.loading = false;
      this.error = false;
      if (this.loadTimeout) {
        clearTimeout(this.loadTimeout);
      }
      console.log("Compêndio carregado com sucesso");
    },
    onIframeError() {
      this.loading = false;
      this.error = true;
      if (this.loadTimeout) {
        clearTimeout(this.loadTimeout);
      }
      console.error("Erro ao carregar o Compêndio");
    },
    reloadIframe() {
      this.loading = true;
      this.error = false;

      const iframe = this.$refs.compendioFrame;
      if (iframe) {
        const currentSrc = iframe.src;
        iframe.src = "about:blank";
        this.$nextTick(() => {
          iframe.src = currentSrc;
        });
      }

      this.loadTimeout = setTimeout(() => {
        if (this.loading) {
          this.error = true;
          this.loading = false;
        }
      }, 15000);
    },
    openInNewTab() {
      window.open(this.iframeUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  width: calc(100% - 60px);
  height: 100vh;
  margin-left: 60px;
}

.divider {
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #ccc;
}

.iframe-wrapper {
  flex-grow: 1;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.external-site-frame {
  width: 100%;
  height: 100%;
  min-height: 600px;
}

.external-site-frame {
  width: 100%;
  height: 100%;
  min-height: 600px;
  transition: opacity 0.3s ease;
}

.external-site-frame.hidden {
  opacity: 0;
  pointer-events: none;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  gap: 1rem;
}

.loading-container p {
  margin: 0;
  color: #6c757d;
  font-size: 1.1rem;
}

.error-container {
  padding: 2rem;
  text-align: center;
}

.error-container h4 {
  color: #dc3545;
  margin-bottom: 1rem;
}

@media screen and (max-width: 700px) {
  .page-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    margin-left: 0px;
  }

  .divider {
    margin: 0px 0;
    border: 0;
    border-top: 1px solid #ccc;
  }

  .iframe-wrapper {
    flex-grow: 1;
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
  }

  .external-site-frame {
    width: 100%;
    height: 100%;
    min-height: 600px;
  }
}
</style>
